import React, { memo } from 'react';
import MypageReturn from '../molecules/MypageReturn';
import RowCenterButton from '../molecules/RowCenterButton';
import DefaultButton from '../molecules/DefaultButton';

interface Props {
  is_staff: boolean;
  review_approval_status: boolean; // 承認状態コード
  requestModule: () => void;
  transitionModernizationFundsInputTypeSelect: () => Promise<any>;
  is_agricultural_funds_kinds_agricultural_fund: boolean;
  is_agricultural_funds_kinds_modernization_fund: boolean;
}

// KWANKGM02040_借入相談結果確認フッタボタン
const FooterConfirmationBorrowingConsultationResults: React.FC<Props> = ({
  is_staff,
  review_approval_status,
  requestModule,
  transitionModernizationFundsInputTypeSelect,
  is_agricultural_funds_kinds_agricultural_fund,
  is_agricultural_funds_kinds_modernization_fund,
}) => {
  // ボタンの表示制御
  const displayButtons = () => {
    if (!review_approval_status) {
      return <></>;
    }

    if (is_agricultural_funds_kinds_agricultural_fund) {
      return (
        <RowCenterButton>
          <DefaultButton label="借入申込をする" strong={false} handleClick={handleClickNext} />
        </RowCenterButton>
      );
    }

    if (is_agricultural_funds_kinds_modernization_fund) {
      return (
        <RowCenterButton>
          <DefaultButton
            label="農業近代化資金の申込をする"
            strong={false}
            handleClick={handleClickTransitionModernizationFundsInputTypeSelect}
            className='a-tag-right-align'
          />
        </RowCenterButton>
      );
    }
  };

  // 「借入申込をする」ボタンをクリックした時のアクション
  const handleClickNext = () => {
    requestModule();
  };

  // 「農業近代化資金の申込をする」ボタンをクリックした時のアクション
  const handleClickTransitionModernizationFundsInputTypeSelect = () => {
    sessionStorage.setItem('modernization_funds_input_type_select_referer', location.href);
    transitionModernizationFundsInputTypeSelect();
  };

  return (
    <>
      {displayButtons()}
      <MypageReturn is_staff={is_staff} />
    </>
  );
};

export default memo(FooterConfirmationBorrowingConsultationResults);
